import  {SvgRelationshipIntro, SvgRelationshipOneA, SvgRelationshipOneAOneTwo, SvgRelationshipOneBOneTwo} from 'components/Images/relationships'

const relationshipsOne = [
  {
    id: "relationships-1",
    type: "question",
    text: "<p>Whose story would you like to explore?</p>",
    backgroundImage: SvgRelationshipIntro,
    options: [
      {
        id: "relationships-1-option-1",
        text: "Sam met Alex at a party at the end of the school year",
        icon: "🎉",
        iconBackground: "#fae3fe",
        nextStepId: "relationships-1a",
      },
      {
        id: "relationships-1-option-2",
        text: "Rani met Amari at surfing lessons they took over the summer",
        icon: "🏄",
        iconBackground: "#fff3d4",
        nextStepId: "relationships-2a",
      },
    ],
  },

  {
    id: "relationships-1a",
    type: "question",
    text:'<p>Sam met Alex at a party at the end of the school year. They&rsquo;ve been seeing each other regularly since then. They have a lot of fun and can talk about most things. Rani says, &ldquo;it sounds like the perfect relationship, do you ever argue?&rdquo;</p><p>Sam responds:</p>',
    backgroundImage: SvgRelationshipOneA,
    options: [
      {
        id: "relationships-1a-option-1",
        text: '“Never. We agree on everything. It’s just so easy.”',
        icon: "🥰",
        iconBackground: "#faf4bb",
        nextStepId: "relationships-1a-learnmore",
      },
      {
        id: "relationships-1a-option-2",
        text: '“We don’t usually argue. Although Alex did get a little upset when I wanted to spend some time alone the other day...”',
        icon: "😔",
        iconBackground: "#faf4bb",
        nextStepId: "relationships-1b-learnmore",
      },
    ],
  },

  {
    id: "relationships-1a-learnmore",
    type: "learnmore",
    text: '<p>Sam feels like there are no disagreements in their relationship. This may seem ideal, but it’s important to remember that even in the most respectful of relationships there are sometimes disagreements and arguments.</p><p> Occasional conflict is a normal part of healthy relationship and can help you learn about and understand each another. </p>',
    scrollText: "<span>Scroll down</span> to learn more.",
    backgroundImage: SvgRelationshipOneA,
    learnmore: {
      title: "More about relationships 🤔",
      content: '<p>All couples experience ups and downs in their relationships. But is important to keep communicating &ndash; everyone has different opinions, values and ideas and that&rsquo;s okay. Make sure to stay open minded and talk to your partner about how you&rsquo;re feeling and what you&rsquo;re thinking. It is normal to disagree in relationships but talking and listening to your partner will help keep the relationship healthy.</p><p>For more information about respectful relationships visit <a href="https://bodytalk.org.au/relationships/respectful-relationships/" target="_blank">Body Talk</a>.</p>'
    },
    nextStepId: "relationships-1a-1-2",
  },

  {
    id: "relationships-1a-1-2",
    type: "question",
    text: "<p>Rani responds, &ldquo;I&rsquo;m so happy for you. You said you are going camping this weekend. Have you talked about sex?&rdquo;</p><p>Sam responds:</p>",
    backgroundImage: SvgRelationshipOneAOneTwo,
    options: [
      {
        id: "relationships-1a-1-2-option-1",
        text: "“We have talked about it A LOT. Like I said Alex is just so easy to talk to.”",
        icon: "🥰",
        iconBackground: "#faf4bb",
        nextStepId: "relationships-1a-1-learnmore",
      },
      {
        id: "relationships-1a-1-2-option-2",
        text: "“I want to talk about it, but I don’t know how to bring it up. This is one thing I’m uncomfortable talking about.”",
        icon: "😣",
        iconBackground: "#faf4bb",
        nextStepId: "relationships-1a-2-learnmore",
      },
    ],
  },

  {
    id: "relationships-1a-1-learnmore",
    type: "learnmore",
    text: '<p>Alex and Sam can express their thoughts and feelings honestly with each other. They are having the conversation about sex before they get caught up in the heat of the moment, when they can think more clearly. This is a sign of healthy relationship.&nbsp;<br />There are lots of things to consider before having sex for the first time.</p>',
    scrollText: "<span>Scroll down</span> to learn more.",
    backgroundImage: SvgRelationshipOneAOneTwo,
    learnmore: {
      title: "More about relationships 🤔",
      content:'<p>These conversations about sex shouldn&rsquo;t just happen once. In a healthy, respectful relationship, you should be able to talk regularly about what you like, what you don&rsquo;t like and your boundaries. You should also be able to talk about whether you are both emotionally ready for sex and how to reduce your risk for STIs and pregnancy (if applicable). It&rsquo;s also important to be a good listener, ask questions when you are unsure and respect your partners&rsquo; boundaries.</p><p>Visit <a href="https://bodytalk.org.au/relationships/am-i-ready-sex-and-relationships/" target="_blank">Body Talk</a> for more information.</p>',
    },
    nextStepId: null,
  },


  {
    id: "relationships-1a-2-learnmore",
    type: "learnmore",
    text: '<p>Even though Sam finds it easy to talk to Alex about most things, they find talking about sex really difficult. It might feel awkward having this conversation but, in most cases, your partner is probably wondering how to bring it up with you too! It may feel weird or uncomfortable at first, but it will get easier.</p>',
    scrollText: "<span>Scroll down</span> to learn more.",
    backgroundImage: SvgRelationshipOneAOneTwo,
    learnmore: {
      title: "More about relationships 🤔",
      content:'<p>These conversations about sex shouldn&rsquo;t just happen once. In a healthy, respectful relationship, you should be able to talk regularly about what you like, what you don&rsquo;t like and your boundaries. You should also be able to talk about whether you are both emotionally ready for sex and how to reduce your risk for STIs and pregnancy (if applicable). It&rsquo;s also important to be a good listener, ask questions when you are unsure and respect your partners&rsquo; boundaries.&nbsp;</p><p>Click <a href="https://bodytalk.org.au/relationships/am-i-ready-sex-and-relationships/" target="_blank">here</a> for more information about sex and relationships.</p>',
    },
    nextStepId: 'relationship-1a-2-1-2',
  },

  {
    id: "relationship-1a-2-1-2",
    type: "question",
    text: "<p>Ky asks, &ldquo;Aren&rsquo;t you worried it&rsquo;s going to come up this weekend? Do you want to have sex?&rdquo; Sam responds, &ldquo;I know we&rsquo;re going camping together but I&rsquo;m not ready for sex. I know Alex is though. How should I bring it up?&rdquo;</p><p>Rani responds:</p>",
    backgroundImage: SvgRelationshipOneBOneTwo,
    options: [
      {
        id: "relationship-1a-2-1-2-option-1",
        text: "“How about just saying straight up: ‘I really like you, but I’m just not ready for sex.”",
        icon: "😳",
        iconBackground: "#faf4bb",
        nextStepId: "relationships-1a-2-1-2-learnmore",
      },
      {
        id: "relationship-1a-2-1-2-option-2",
        text: "“Just say: ‘Let’s take things slow.’ You can let Alex know that you really like where your relationship is at right now and want to take your time and talk about it with them before deciding to have sex.”",
        icon: "🙃",
        iconBackground: "#faf4bb",
        nextStepId: "relationships-1a-2-1-2-learnmore",
      },
    ],
  },

  {
    id: "relationships-1a-2-1-2-learnmore",
    type: "learnmore",
    text: '<p>When it comes to sex, there are many ways to start the conversation. It may feel weird or uncomfortable, but it will get easier. With most things, Sam finds it easy to express their thoughts and feelings with Alex. We know it can be awkward at first, but sex should be a part of the conversation.</p>',
    scrollText: "<span>Scroll down</span> to learn more.",
    backgroundImage: SvgRelationshipOneBOneTwo,
    learnmore: {
      title: "More about relationships 🤔",
      content:'<p>Talking about what you do and don&rsquo;t want when it comes to sex is an important part of a healthy and respectful relationship.</p><p>Before these conversations think about how you feel and what you want to say so that it&rsquo;s a bit easier to communicate. During the conversation, be clear and direct. Let them know how you feel and what you are you are comfortable doing even if you aren&rsquo;t ready for sex.</p>',
    },
    nextStepId: null,
  },

  {
    id: "relationships-1b-learnmore",
    type: "learnmore",
    text: '<p>Sam likes spending time alone but Alex doesn&rsquo;t like it when Sam wants to spend time alone. Keep in mind that spending time alone is as important as spending time together in a healthy, respectful relationship. Everyone has different wants and needs, and you and your partner may not always agree on things.</p><p>Even in a respectful relationship you will come across disagreements. Conflict is normal and healthy and can help you learn about and understand each another.</p>',
    scrollText: "<span>Scroll down</span> to learn more.",
    backgroundImage: SvgRelationshipOneAOneTwo,
    learnmore: {
      title: "More about relationships 🤔",
      content:'<p>It&rsquo;s important to deal with conflict as it arises! It&rsquo;s how you manage your differences and come to resolutions that are important in maintaining a respectful relationship.</p><p>Some ways differences can be managed respectfully include:</p><p>- Expressing feelings calmly and in a non-blaming way<br />- Understanding that it is ok to have differences and to have different opinions<br />- Listening and understanding each other&rsquo;s point of view<br />- Being open to learning about new things and about each other&rsquo;s values<br />- Communicating wants and needs clearly<br />- Being willing to resolve disagreements, to negotiate and come to a compromise</p><p>Click <a href="https://bodytalk.org.au/relationships/respectful-relationships/" target="_blank">here</a> for more information on respectful relationships.</p>',
    },
    nextStepId: 'relationships-1b-1-2',
  },

  {
    id: "relationships-1b-1-2",
    type: "question",
    text: "<p>Ky asks, “what happened?”",
    backgroundImage: SvgRelationshipOneBOneTwo,
    options: [
      {
        id: "relationships-1b-1-2-option-1",
        text: "“We talked about it. I let Alex know that I really love spending time with them, but I need some 'me' time. Alex didn’t really get it at first. But after talking about it, they understood that it was important to me.”",
        icon: "😊",
        iconBackground: "#faf4bb",
        nextStepId: "relationships-1b-1-learnmore",
      },
      {
        id: "relationships-1b-1-2-option-2",
        text: "“Alex got quite upset and accused me of being tired of them. I tried to explain that sometimes I just need time to myself, but Alex didn’t want to listen. They said I must not care about them and stormed off. The day after Alex texted me and acted like nothing happened.”",
        icon: "😯",
        iconBackground: "#faf4bb",
        nextStepId: "relationships-1b-2-learnmore",
      },
    ],
  },
  {
    id: "relationships-1b-1-learnmore",
    type: "learnmore",
    text: '<p>Sam felt comfortable expressing themselves without judgement. Alex and Sam were able to talk things through and compromise. In the end Sam felt accepted and free to be themself. This is a sign of a respectful relationship. Communicating, valuing the differences between each other and being willing to resolve disagreements are important to maintaining a respectful relationship.</p>',
    scrollText: "<span>Scroll down</span> to learn more.",
    backgroundImage: SvgRelationshipOneBOneTwo,
    learnmore: {
      title: "More about relationship 🤔",
      content:'<p>Communication in relationships allows partners to explain to each other what they are experiencing and what their needs are. Communication is not only important for growth, but also essential for building a long-lasting and fulfilling relationships.</p><p>For more information about respectful relationships visit <a href="https://bodytalk.org.au/relationships/respectful-relationships/" target="_blank">Body Talk</a>.</p>',
    },
    nextStepId: null,
  },

  {
    id: "relationships-1b-2-learnmore",
    type: "learnmore",
    text: '<p>Alex appears to be trying to control what Sam does. That, along with how Alex reacted, could be a sign of an unhealthy relationship. Although partners may have their individual communication styles when it comes to arguing, it is important to be respectful. It is ok to step away from an argument if you need some time to process, but it is important to be willing to resolve disagreements, to negotiate and come to a compromise.&nbsp;</p>',
    scrollText: "<span>Scroll down</span> to learn more.",
    backgroundImage: SvgRelationshipOneBOneTwo,
    learnmore: {
      title: "More about relationship 🤔",
      content:'<p>People in relationships do not always agree with each other and sometimes they argue. As you learn about one another, you may come across things that you do not agree on, or things that frustrate you about the other person. How you handle conflict in your relationship is what&rsquo;s important, whether the issue is something that you can resolve, or if it&rsquo;s ongoing and causes problems in your relationship.&nbsp;</p><p>For more information about respectful relationships visit <a href="https://bodytalk.org.au/relationships/feeling-safe/" target="_blank">Body Talk</a>.</p>',
    },
    nextStepId: null,
  },


];

export default relationshipsOne;
